import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AlertService } from 'src/app/service/alert.service';
import { ClientesService } from 'src/app/service/clientes.service';
import { LicencasService } from 'src/app/service/licencas.service';
import Swal from 'sweetalert2';
import { EscolherUsuarioEnviarTokenComponent } from '../escolher-usuario-enviar-token/escolher-usuario-enviar-token.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-adquirir-licenca',
  templateUrl: './adquirir-licenca.component.html',
  styleUrls: ['./adquirir-licenca.component.css'],
})
export class AdquirirLicencaComponent implements OnInit {
  public licencaForm: FormGroup = this.formBuilder.group({
    fk_licenca: ['', Validators.required],
    fk_cliente: ['', Validators.required],
    ts_ativacao: ['', Validators.required],
    it_dias_duracao: ['', Validators.required],
    select_opcoes: ['', Validators.required],
    vc_nota_fiscal: [''],
    vc_ordem_servico: [''], 
    vc_proposta: [''], 
    ts_expiracao: [''],
  });
  public licencas: any = [];
  public usinas: any = [];
  public campos: any = [];
  public opcoes: any = [];
  public dataMinima = new Date().toLocaleDateString('pt-BR').split('/').reverse().join('-');
  public campoSelecionado: string = ''; 

  checked = false;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private licencaService: LicencasService,
    private serviceClientes: ClientesService,
    private alertService: AlertService,
    public dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.listarLicenca();
    this.listarClientes();
    this.onChangeLicenca();
    this.onChangeOpcoes();
    this.setarDataExpiração();
  }

  toggleFormControl(controlName: string, deveDesabilitar: boolean): void {
    const control = this.licencaForm.get(controlName);
  
    if (control) {
      deveDesabilitar ? control.disable() : control.enable();
    }
  }

  cancel() {
    this.router.navigate(['configuracao/licencas']);
  }

  listarLicenca() {
    this.licencaService.listarLicencaComCampos().subscribe((licencasResposta: any) => {
      this.licencas = licencasResposta;
    });
  }

  listarClientes() {
    this.serviceClientes.listarServiceClientes().subscribe((resp) => {
      this.usinas = resp;
    });
  }

  onChangeLicenca() {
    this.licencaForm.get('fk_licenca')?.valueChanges.subscribe((novaLicenca: any) => {
      this.limparCamposAdicionais();
      var dadosNovaLicenca = this.licencas.filter((licenca: any) =>
        licenca.sr_id == novaLicenca
      );
      this.adicionarCamposNoFormulario(dadosNovaLicenca[0]);
    })
  }

  onChangeOpcoes(): void {
    this.licencaForm.get('select_opcoes')?.valueChanges.subscribe((opcaoSelecionada: any) => {
    this.campoSelecionado = opcaoSelecionada;
    this.validarNFouOS();
    })
  }

  setarDataExpiração() {
    this.licencaForm.get('ts_ativacao')?.valueChanges.subscribe((dataAtivacao: any) => {
      if (this.licencaForm.get('it_dias_duracao')?.value) {
        this.calcularDataExpiracao();
      };
    })
    this.licencaForm.get('it_dias_duracao')?.valueChanges.subscribe((dataAtivacao: any) => {
      if (this.licencaForm.get('ts_ativacao')?.value) {
        this.calcularDataExpiracao();
      };
    })
  }

  adicionarCamposNoFormulario(dadosLicenca: any) {
    dadosLicenca.campos_adicionais.forEach((campo: any) => {
      var nomeCampo = campo.vc_campo.replace(/ /g, "_");
      this.licencaForm.addControl(nomeCampo, this.formBuilder.control('', Validators.required));
      this.campos.push({ 'nome_campo': campo.vc_campo, 'nome_formulario': nomeCampo })
    });
  }

  validarNFouOS(): void {
    const campo = this.campoSelecionado;
    
    const campos = ['vc_nota_fiscal', 'vc_ordem_servico', 'vc_proposta'];
    campos.forEach(c => {
     if (c !== campo) {
        this.licencaForm.get(c)?.clearValidators();
        this.licencaForm.get(c)?.reset();
        this.licencaForm.get(c)?.updateValueAndValidity();
      }
    });


    this.licencaForm.get(campo)?.setValidators(Validators.required);
    this.licencaForm.get(campo)?.updateValueAndValidity();
  }

  adquirirLicenca() {
    this.licencaService.adquirirLicenca(this.licencaForm.value).subscribe(
      (licenca: any) => {
        var token = licenca.token;
        Swal.fire({
          icon: 'success',
          title: 'Token gerado com sucesso!',
          text: token,
          confirmButtonText: 'Copiar token',
          confirmButtonColor: '#00AA5B',
          allowOutsideClick: false,
          showDenyButton: true,
          denyButtonText: 'Enviar para e-mail',
          denyButtonColor: '#5BC0DE'
        }).then((result: any) => {
          if (result.isConfirmed) {
            this.copiarParaAreaDeTranferencia(token);
            this.gerarOutroTokenOuSair('Copiado para área de transferencia!');
          } else if (result.isDenied) {
            this.enviarViaEmail(licenca);
          }
        })
      },
      (erro) => {
        this.alertService.error(erro);
      }
    );
  }

  limparCamposAdicionais() {
    this.campos.forEach((campo: any) => {
      this.licencaForm.removeControl(campo.nome_formulario);
    });
    this.campos = [];
  }

  calcularDataExpiracao() {
    if (this.licencaForm.get('it_dias_duracao')?.value != 0) {
      const dataOriginal = this.licencaForm.get('ts_ativacao')?.value;
      const diasASomar = this.licencaForm.get('it_dias_duracao')?.value;
      const dataObj = new Date(dataOriginal);
      dataObj.setDate(dataObj.getDate() + parseInt(diasASomar, 10) + 1);
      const ano = dataObj.getFullYear();
      const mes = (dataObj.getMonth() + 1).toString().padStart(2, '0');
      const dia = dataObj.getDate().toString().padStart(2, '0');
      const dataExpiracao = `${ano}-${mes}-${dia}`;
      this.licencaForm.get('ts_expiracao')?.setValue(dataExpiracao);
    } else {
      this.licencaForm.get('ts_expiracao')?.setValue(null);
    }
  }

  copiarParaAreaDeTranferencia(token: any) {
    const elementoTemporario = document.createElement('textarea');
    elementoTemporario.value = token;
    document.body.appendChild(elementoTemporario);
    elementoTemporario.select();
    document.execCommand('copy');
    document.body.removeChild(elementoTemporario);
  }

  gerarOutroTokenOuSair(mensagem: any) {
    Swal.fire({
      title: mensagem,
      showDenyButton: true,
      confirmButtonText: 'Gerar outro token',
      confirmButtonColor: '#00AA5B',
      denyButtonText: `Sair`,
    }).then((result: any) => {
      if (result.isConfirmed) {
        this.campos.forEach((campo: any) => {
          this.licencaForm.get(campo.nome_formulario)?.setValue('');
        });
      } else if (result.isDenied) {
        this.router.navigate(['configuracao/licencas']);
      }
    })
  }

  enviarViaEmail(licenca: any){
    var nomeDaLicenca = this.licencas.filter((licenca: any) => {
      return licenca.sr_id == this.licencaForm.get('fk_licenca')?.value
    })
    nomeDaLicenca = nomeDaLicenca[0]?.vc_nome;
    const dialogRef = this.dialog.open(EscolherUsuarioEnviarTokenComponent, {
      width: '35vw',
      data: [licenca, nomeDaLicenca]
    });
    dialogRef.afterClosed().subscribe(result => {
      this.gerarOutroTokenOuSair('Enviado para os emails solicitados')
    });
  }
}
